import { search } from 'jmespath';
// tslint:enable:no-submodule-imports
export function searchIsConflicted(vicciData) {
    return search(vicciData, 'validationData.conflicted') || false;
}
export function searchCarlineId(vicciData) {
    return search(vicciData, 'vehicleConfiguration.carlineKey') || '';
}
export function searchExteriorId(vicciData) {
    return search(vicciData, 'vehicleConfiguration.exterior.code') || '';
}
export function searchOptionIds(vicciData) {
    return search(vicciData, 'vehicleConfiguration.features[].code') || [];
}
export function searchInteriorId(vicciData) {
    return search(vicciData, 'vehicleConfiguration.interior.code') || '';
}
export function searchModelId(vicciData) {
    return search(vicciData, 'vehicleConfiguration.modelKey') || '';
}
export function searchModelYear(vicciData) {
    return search(vicciData, 'vehicleConfiguration.modelYear') || '';
}
export function searchModelVersion(vicciData) {
    return search(vicciData, 'vehicleConfiguration.modelVersion') || '';
}
export function searchSalesGroupId(vicciData) {
    return search(vicciData, 'vehicleConfiguration.salesgroupKey') || '';
}
export function searchTrimName(vicciData) {
    return (search(vicciData, "vehicleConfiguration.modelFilters[?type == 'EquipmentLine'].text | [0]") || '');
}
